__turbopack_context__.v({
  "body": "ChangelogNotification-module__t_H7Ja__body",
  "close": "ChangelogNotification-module__t_H7Ja__close",
  "cta": "ChangelogNotification-module__t_H7Ja__cta",
  "header": "ChangelogNotification-module__t_H7Ja__header",
  "notif": "ChangelogNotification-module__t_H7Ja__notif",
  "title": "ChangelogNotification-module__t_H7Ja__title",
  "version": "ChangelogNotification-module__t_H7Ja__version",
});
